import { FormattedMessage, IntlProvider } from 'react-intl'
import { getSourceData } from '@/components/regionen/pageRegionSlug/mapData/utils/getMapDataUtils'
import { parseSourceKeyTilda } from '../utils/sourceKeyUtils/sourceKeyUtilsTilda'
import { Disclosure } from './Disclosure/Disclosure'
import type { InspectorFeature } from './Inspector'
import { NoticeMaproulette } from './InspectorFeatureSource/NoticeMaproulette'
import { NoticeTransformedGeometry } from './InspectorFeatureSource/NoticeTransformedGeometry'
import { TagsTable } from './TagsTable/TagsTable'
import { translations } from './TagsTable/translations/translations.const'
import { extractOsmTypeIdByConfig } from './Tools/osmUrls/extractOsmTypeIdByConfig'
import { osmTypeIdString } from './Tools/osmUrls/osmUrls'
import { ToolsLinks } from './Tools/ToolsLinks'
import { ToolsOtherProperties } from './Tools/ToolsOtherProperties'
import { ToolsWrapper } from './Tools/ToolsWrapper'

export const InspectorFeatureTilda = ({ sourceKey, feature }: InspectorFeature) => {
  const { geometry, properties } = feature
  const sourceId = sourceKey ? parseSourceKeyTilda(sourceKey).sourceId : ''
  const sourceData = sourceId ? getSourceData(sourceId) : null
  const { osmType, osmId } =
    properties && sourceData
      ? extractOsmTypeIdByConfig(properties, sourceData.osmIdConfig)
      : { osmType: undefined, osmId: undefined }
  const osmTypeId = osmType && osmId ? osmTypeIdString(osmType, osmId) : undefined

  if (!sourceKey || !properties) return null
  if (!sourceData?.inspector.enabled) return null
  if (!sourceId) return null

  return (
    <IntlProvider messages={translations} locale="de" defaultLocale="de">
      <Disclosure title={<FormattedMessage id={`${sourceId}--title`} />} objectId={osmTypeId}>
        {/* Takes no space when empty; `pb-2` spaces the notices from the table */}
        <div className="pb-2 empty:hidden">
          <NoticeTransformedGeometry sourceId={sourceId} properties={properties} />
          <NoticeMaproulette
            sourceId={sourceId}
            osmTypeIdString={osmTypeId}
            kind={properties?.category || properties?.road}
            properties={properties}
            geometry={geometry}
          />
        </div>

        <TagsTable
          properties={properties}
          sourceDocumentedKeys={sourceData.inspector.documentedKeys}
          sourceId={sourceId}
        />

        {/* <Verification properties={properties} sourceId={sourceId} /> */}

        <ToolsWrapper>
          <ToolsLinks
            feature={feature}
            editors={sourceData.inspector.editors}
            osmIdConfig={sourceData.osmIdConfig}
          />
          <ToolsOtherProperties feature={feature} sourceId={sourceId} />
        </ToolsWrapper>
      </Disclosure>
    </IntlProvider>
  )
}
